<template>
  <section class="content">
        <form >
            <website ref="website"/>
      <div class="top-space"></div>
      <div class="page-width">
	<div >
	 <div class="col-sm-8">
		<div class="contact-form form-vertical">
			<div class="page-title">
              	
					<h1 class="h2">Drop Us A Line</h1>
				
          	</div>
			<div >
              				
				
          	</div>
			<!-- <form method="post" action="/contact#contact_form" id="contact_form" 
      accept-charset="UTF-8" class="contact-form"><input type="hidden" 
      name="form_type" value="contact" /><input type="hidden" name="utf8" value="✓" /> -->

			<!-- <div class="grid grid--half-gutters"> -->
				<div class="grid__item medium-up--one-half"> 
					<input type="text" id="ContactFormName" name="contact[name]" placeholder="Name"  value="">
				</div>
				<div class="grid__item medium-up--one-half"> 
					<input type="email" id="ContactFormEmail" name="contact[email]" placeholder="Email"  autocorrect="off" autocapitalize="off" value="" class="">
				</div>
			<!-- </div> -->
			
      	<div class="grid__item medium-up--one-half"> 
				<input type="tel"  id="ContactFormPhone" name="contact[phone]" pattern="[0-9\-]*" placeholder="Phone Number"  value="">
				</div>
			
			
			<Textarea rows="8" id="ContactFormMessage"  cols="60" name="contact[body]" placeholder="Your Message" ></Textarea>
			<!-- <input type="submit" class="btn" value="Send"> -->
      	<div class="grid__item medium-up--one-half"> 
       <Button  label="Send" style="width: 12%;" class="btn" >
</Button>
        </div>
			<!-- </form> -->
       

    </div>
   </div>
            <div class="col-sm-4">
		
		<ul class="contact-address">
				<li><i class="ad ad-map-marker-al"></i><p>Samakhusi, Kathmandu</p></li>
                <li class="phone"><i class="ad ad-phone-l"></i><p>+91-9911437000</p></li>
                <li class="email"><i class="ad ad-envelope-l"></i><p>Info@lilpicks.com</p></li>
                          
		</ul>
		<hr/>
		
		
		
		<div class="follow-us"><ul class="list--inline site-footer__social-icons social-icons">
  <li><a class="social-icons__link" href="https://www.facebook.com/lilpickscouture" target="_blank" title="Lilpicks on Facebook"><i class="ad ad-facebook-square"></i> <span class="icon__fallback-text">Facebook</span></a></li>
  
  
  
  <li><a class="social-icons__link" href="https://www.instagram.com/lilpickscouture/" target="_blank" title="Lilpicks on Instagram"><i class="ad ad-instagram"></i> <span class="icon__fallback-text">Instagram</span></a></li>
  
  
  
  
  
</ul> </div>
		 
     </div>
     </div>
     </div>
      <footerWebsite ref="footerWebsite"/>
</form>
  </section>
</template>
<script>
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import website from '../ecommerce/website.vue'
import footerWebsite from '../ecommerce/footerWebsite.vue'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Textarea from 'primevue/textarea'
export default {
  name: 'contactUs',
  props: ['contactUs'],
  data() {
    return {
      name: '',
      englishDateEnabled: true,
      ecommerceInquiryDTO: '',
      transactionDate: null,
      account: '',
      txnAmountDr: 0,
      txnAmountCr: 0,
      narration3: '',
      narration: '',
      drCr: '',
      drtotal: 0,
      crTotal: 0,
      difference: 0,
      chequeDate: null,
      chequeNumber: '',
      transactionDetailDTOList: [],
      transactionDeleteList: [],
      bank: false,
      editing: false,
      voucherNo: null,
      editDTO: false,
      index: null,
      tranId: null,
      tranModuleType: null,
      loading: false,
      cheque: false,
      filteredAccounts: null,
      products: null
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  },
  components: {
    Button,
    InputText,
    Column,
    DataTable,
    website,
    footerWebsite,
    Textarea
  }
}
</script>
<style scoped  src="@../../../static/css/website.css" >
</style>



// WEBPACK FOOTER //
// contactUs.vue?28843a07